<template>
  <div>

    <!-- container and row -->
    <div id="trip-results" class="container mt-3" :class="{ 'container-mobile': isMobile }">

      <!-- tab between future and current trips -->
      <div v-if="routes.length > 0 && compareFutureCurrent" class="tabs-future-current-options mt-5">
        <ul class="nav nav-tabs">
          <li class="nav-item" v-for="item in [{value: 'future', title: 'Future Options'}, {value: 'current', title: 'Current Options'}]">
            <a class="nav-link"
              :class="{ active: (resultsViewActive === item.value) }"
              @click="resultsViewActive = item.value">{{ item.title }}</a>
          </li>
        </ul>
        <hr style="margin-top:0">
      </div>

      <!-- alert for errors -->
      <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errors">
        {{ errors }}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- trip options -->
      <trip-planner-options
        class="mb-3"
        :class="{ loading: loading }"
        v-if="routes.length > 0"></trip-planner-options>

      <div class="loading-txt ml-3" v-if="loading && routes.length < 1">Loading...</div>

      <transition name="appear">
      <div class="row" v-if="routes.length > 0 && resultsViewActiveChanged">

        <!-- each route -->
        <div v-for="(route, routeIndex) in routes"
             :key="routeIndex"
             :class="{ loading: loading }"
             class="colA col-xs-12 col-sm-12 col-md-4 col-lg-4">

          <!-- card -->
          <div class="card text-dark mb-3" :class="{ active: (selectedTripIndex === routeIndex) }">

            <!-- trip summary (card body) -->
            <trip-planner-results-summary
              :route="route"
              :routeIndex="routeIndex"></trip-planner-results-summary>

            <!-- trip details (for mobile view) -->
            <div v-if="isMobile && selectedTripIndex === routeIndex">
              <trip-planner-map :isFuture="isFuture"></trip-planner-map>
              <trip-planner-results-details></trip-planner-results-details>
            </div>

            <!-- footer -->
            <div class="card-footer text-muted" v-if="isFuture">
              <trip-planner-future-benefits :routeIndex="routeIndex"></trip-planner-future-benefits>
            </div>

          </div>
          <!-- card END -->

          <!-- active card indicator (desktop only) -->
          <div v-if="!isMobile && selectedTripIndex === routeIndex" class="card-active"></div>

        </div>
        <!-- each route END -->

      </div>
      <!-- row END -->
      </transition>


    </div>
    <!-- container and row END -->

    <!-- trip details (for non-mobile view) -->
    <div v-if="!isMobile">
      <div class="container mt-3">
        <div class="row">
          <transition name="appear">
            <div class="col-sm-4" v-if="selectedTripIndex > -1 && selectedTripIndexChanged">
              <trip-planner-results-details></trip-planner-results-details>
            </div>
          </transition>
          <div :class="{ 'col-sm-8': (selectedTripIndex > -1), 'col-sm-12': (selectedTripIndex < 0) }">
            <transition name="appear-delay-02s">
              <trip-planner-map :isFuture="isFuture" v-if="componentReady && selectedTripIndexChanged"></trip-planner-map>
            </transition>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
// import DepartArriveOptions from './DepartArriveOptions'
import TripPlannerOptions from './TripPlannerOptions.vue'
import TripPlannerResultsSummary from './TripPlannerResultsSummary.vue'
import TripPlannerResultsDetails from './TripPlannerResultsDetails.vue'
import TripPlannerFutureBenefits from './TripPlannerFutureBenefits.vue'
import TripPlannerMap from './TripPlannerMap.vue'
import mixinCommon from '../mixins/common'
import mixinFilters from '../mixins/filters'

export default {
  name: 'trip-planner-results',
  components: { TripPlannerOptions, TripPlannerResultsSummary, TripPlannerResultsDetails, TripPlannerFutureBenefits, TripPlannerMap },
  props: ['isFuture'],
  mixins: [mixinCommon, mixinFilters],
  data () {
    return {
      componentReady: false,
      resultsViewActiveChanged: true,
      selectedTripIndexChanged: true,
    }
  },
  computed: {
    loading () { // get router params and query
      return this.$store.getters['tripPlanner/ajax'].loading;
    },
    currentTripResults () {
      return this.$store.getters['tripPlanner/currentResults'];
    },
    compareFutureCurrent () {
      return this.$store.getters['tripPlanner/compareFutureCurrent'];
    },
    errors () { // get router params and query
      let summary = this.$store.getters['tripPlanner/tripSummary']
      if (summary.errors) {
        return summary.message
      }
      return false
    },
    router () { // get router params and query
      return this.$store.getters['tripPlanner/router'];
    },
    routes () {
      return this.$store.getters['tripPlanner/tripRoutes'];
    },
    totalRoutes () {
      return this.routes.length
    },
    selectedTripIndex () {
      return parseInt(this.$store.getters['tripPlanner/selectedTripIndex'])
    },
    selectedTrip () {
      if (this.selectedTripIndex < 0) {
        return false
      }
      if (this.routes.length < 1) {
        return false
      }
      if (!this.routes[this.selectedTripIndex]) {
        return false
      }
      return this.routes[this.selectedTripIndex]
    },
    resultsViewActive: {
      get () {
        return this.$store.getters['tripPlanner/resultsViewActive']
      },
      set (bool) {
        this.$store.commit('tripPlanner/SET_CURRENT_RESULTS_VIEW', bool)
      }
    }
  },
  watch: {
    routes (routes) {
      if (routes.length && this.$route.query.autoselect) {
        this.$router.push({
            name  : (this.$route.path.substr(0,3) === '/es') ? 'es-trip-planner-trip-details' : 'trip-planner-trip-details',
            params: Object.assign(this.router.params, { tripIndex: 0 }),
            query : this.router.query,
          });
      }
    },   
    selectedTripIndex () {
      this.selectedTripIndexChanged = false
      setTimeout(() => this.selectedTripIndexChanged = true, 10)
    },
    resultsViewActive () {
      this.resultsViewActiveChanged = false
      setTimeout(() => this.resultsViewActiveChanged = true, 100)
    }
  },
  mounted () {
    this.componentReady = true
  }
}
</script>

<style lang="scss" scoped>
.card {
  border-radius: 0;
  border-top-right-radius: 35px;
}
.line-no {
  margin-left: 3px;
  padding: 2px;
}
.icon-icon-triangle-right {
  font-size:75%;
}
.loading {
  opacity: 0.6;
}

.card-active {
  background-color: #fff;
  width:100%;
  height: 10px;
}

hr {
  border-top: 3px solid rgba(0,0,0,.15);
}

.tabs-future-current-options a,
.tabs-future-current-options .nav-tabs .nav-item.show .nav-link,
.tabs-future-current-options .nav-tabs .nav-link.active {
  color: #fff;
  border:none;
  background: none;
  cursor: pointer;
}


.tabs-future-current-options .active,
.tabs-future-current-options .nav-tabs .nav-item.show .nav-link,
.tabs-future-current-options .nav-tabs .nav-link.active {
  border-bottom: solid 1px #fff;
}
.tabs-future-current-options li {
  width: 50%;
}
.tabs-future-current-options .nav-tabs {
  border:none;
}
</style>



// WEBPACK FOOTER //
// src/components/TripPlannerResults.vue